import { Delete, UploadFile } from "@mui/icons-material";
import { Button, Checkbox, Divider, FormControl, Grid, IconButton, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, TextField, Tooltip, Typography } from "@mui/material";
import { useEffect } from "react";

const RequestSupportStep = ({ props }) => {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [])

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
                <TextField
                    placeholder="What is the reason for your request for support?"
                    label="Requested support reason"
                    id="outlined-size-small"
                    name="requested_support_reason"
                    multiline
                    rows={5}
                    maxRows={10}
                    fullWidth
                    value={props.formData.requested_support_reason}
                    onChange={e => props.handleInputChange(e)}
                    InputLabelProps={{ shrink: true }}
                    helperText={props.emptyFormProps.includes('requested_support_reason') ? 'This field is required' : ''}
                    error={!!props.emptyFormProps.includes('requested_support_reason')}
                />
            </Grid>
            <Grid item xs={12} sm={12}>
                <TextField
                    placeholder="Please describe in detail the work that you expect the SPICE expert to perform"
                    label="SPICE expert work expectations"
                    id="outlined-size-small"
                    name="expert_work_expectations"
                    multiline
                    rows={5}
                    maxRows={10}
                    fullWidth
                    value={props.formData.expert_work_expectations}
                    onChange={e => props.handleInputChange(e)}
                    InputLabelProps={{ shrink: true }}
                    helperText={props.emptyFormProps.includes('expert_work_expectations') ? 'This field is required' : ''}
                    error={!!props.emptyFormProps.includes('expert_work_expectations')}
                />
            </Grid>
            <Grid item xs={12} sm={12}>
                <TextField
                    placeholder="What is the expected outcome of your project?"
                    label="Expected project outcome"
                    id="outlined-size-small"
                    name="expected_project_outcome"
                    multiline
                    rows={5}
                    maxRows={10}
                    fullWidth
                    value={props.formData.expected_project_outcome}
                    onChange={e => props.handleInputChange(e)}
                    InputLabelProps={{ shrink: true }}
                    helperText={props.emptyFormProps.includes('expected_project_outcome') ? 'This field is required' : ''}
                    error={!!props.emptyFormProps.includes('expected_project_outcome')}
                />
            </Grid>
        </Grid>
    );
}
export default RequestSupportStep;